// Tests: src/app/migrations/migrations.spec.ts
import { MigrationDefinition } from './migration.types';

/**
 * Migration: V12 → V13
 *
 * Grubenprotokoll-Vorbereitung: zwei neue optionale Felder je `SubstratZeile`
 * (`schichtLage`, `perstruktionszone`). Upgrade ist additiv — nichts zu
 * backfillen. Downgrade entfernt die Felder aus jeder Substratzeile (Daten,
 * die nur auf der Grube-Profil-Maske erfasst wurden, gehen verloren).
 */
export const migrationV12ToV13: MigrationDefinition = {
  fromVersion: 12,
  toVersion: 13,

  upgrade(doc: any): any {
    doc.version = 13;
    return doc;
  },

  downgrade(doc: any): any {
    if (Array.isArray(doc.Substratfolge)) {
      for (const row of doc.Substratfolge) {
        if (row && typeof row === 'object') {
          delete row.schichtLage;
          delete row.perstruktionszone;
        }
      }
    }
    doc.version = 12;
    return doc;
  },

  dataLossWarnings: [
    'Beim Downgrade gehen pro Substratzeile schichtLage und perstruktionszone verloren'
  ]
};
